<template>
  <div class="wrapper signup-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left"></div>
        <div class="right">
          <input class="c-checkbox" type="checkbox" id="start" />
          <input class="c-checkbox" type="checkbox" id="progress1" />
          <input class="c-checkbox" type="checkbox" id="progress2" />
          <input class="c-checkbox" type="checkbox" id="progress3" />
          <input class="c-checkbox" type="checkbox" id="progress4" />
          <input class="c-checkbox" type="checkbox" id="progress5" />
          <input class="c-checkbox" type="checkbox" id="finish" />

          <input class="c-checkbox return-check" type="checkbox" id="return" />
          <input class="c-checkbox return-check" type="checkbox" id="return1" />
          <input class="c-checkbox return-check" type="checkbox" id="return2" />
          <input class="c-checkbox return-check" type="checkbox" id="return3" />

          <div class="shutter" style="display: none"></div>
          <div class="c-form__progress"></div>
          <h1>
            {{ $t("SIGN UP") }}
          </h1>
          <div class="c-formContainer">
            <!-- last -->
            <div class="c-welcome">
              {{ $t("WELCOME TO") }}<br />
              {{ $t("CDP SYSTEM") }}
              <div class="img">
                <div class="link-btn link-over">
                  <img
                    src="../assets/img/signup-btn-img.svg"
                    alt=""
                    class="blink-animation"
                  />
                </div>
              </div>
            </div>
            <!-- last -->
            <div class="btn">
              <form class="c-form" action="">
                <!-- 1 -->
                <div class="c-form__group introducer-area active">
                  <label class="c-form__label" for="introducer">
                    <input
                      type="text"
                      id="introducer"
                      class="c-form__input"
                      placeholder=" "
                      required
                    />
                    <label class="c-form__next" for="start" role="button">
                      <span class="c-form__nextIcon">
                        <img src="../assets/img/signin-arrow-img.svg" alt="" />
                      </span>
                    </label>

                    <span class="c-form__groupLabel">{{
                      $t("INTRODUCER")
                    }}</span>
                    <b class="c-form__border"></b>
                  </label>
                  <label class="c-form__label" for="position">
                    <input
                      type="text"
                      id="position"
                      class="c-form__input"
                      placeholder=" "
                      required
                    />
                    <label class="c-form__next" for="" role="button">
                      <span class="c-form__nextIcon">
                        <img src="../assets/img/signin-arrow-img.svg" alt="" />
                      </span>
                    </label>
                    <span class="c-form__groupLabel"
                      >{{ $t("POSITION ID") }}（{{ $t("any") }}）</span
                    >
                    <b class="c-form__border"></b>
                  </label>
                  <div class="select-radio">
                    <input type="radio" name="position" id="left" checked />
                    <label for="left">{{ $t("LEFT") }}</label>
                    <input type="radio" name="position" id="right" />
                    <label for="right">{{ $t("RIGHT") }}</label>
                  </div>
                  <button
                    class="return-txt"
                    type="button"
                    v-on:click="toReturnBtn()"
                  >
                    ◀︎ Back
                  </button>
                </div>
                <!-- ./1 -->

                <!-- 2 -->
                <div class="c-form__group">
                  <label class="c-form__label" for="username">
                    <input
                      type="text"
                      id="username"
                      class="c-form__input"
                      placeholder=" "
                      required
                    />
                    <label class="c-form__next" for="progress1" role="button">
                      <span class="c-form__nextIcon">
                        <img src="../assets/img/signin-arrow-img.svg" alt="" />
                      </span>
                    </label>

                    <span class="c-form__groupLabel">{{
                      $t("USER NAME")
                    }}</span>
                    <b class="c-form__border"></b>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./2 -->

                <!-- 3 -->
                <div class="c-form__group">
                  <label class="c-form__label" for="email">
                    <input
                      type="email"
                      id="email"
                      class="c-form__input"
                      placeholder=" "
                      required
                    />
                    <label class="c-form__next" for="progress2" role="button">
                      <span class="c-form__nextIcon">
                        <img src="../assets/img/signin-arrow-img.svg" alt="" />
                      </span>
                    </label>

                    <span class="c-form__groupLabel">{{
                      $t("Email address")
                    }}</span>
                    <b class="c-form__border"></b>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./3 -->

                <!-- 4 -->
                <div class="c-form__group">
                  <p class="code-msg">
                    {{
                      $t(
                        "Please enter the verification code sent to your email address below."
                      )
                    }}
                  </p>
                  <label class="c-form__label" for="code">
                    <input
                      type="text"
                      id="code"
                      class="c-form__input"
                      placeholder=" "
                      required
                    />
                    <label class="c-form__next" for="progress3" role="button">
                      <span class="c-form__nextIcon">
                        <img src="../assets/img/signin-arrow-img.svg" alt="" />
                      </span>
                    </label>

                    <span class="c-form__groupLabel">{{
                      $t("Enter confirmation code")
                    }}</span>
                    <b class="c-form__border"></b>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./4 -->

                <!-- 5 -->
                <div class="c-form__group">
                  <label class="c-form__label" for="fpass">
                    <input
                      type="password"
                      id="fpass"
                      class="c-form__input"
                      placeholder=" "
                    />

                    <label class="c-form__next" for="progress4" role="button">
                      <span class="c-form__nextIcon"
                        ><img src="../assets/img/signin-arrow-img.svg" alt=""
                      /></span>
                    </label>

                    <span class="c-form__groupLabel">{{ $t("PASSWORD") }}</span>
                    <b class="c-form__border"></b>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./5 -->

                <!-- 6 -->
                <div class="c-form__group">
                  <label class="c-form__label" for="fpass3">
                    <input
                      type="password"
                      id="fpass3"
                      class="c-form__input"
                      placeholder=" "
                    />

                    <label class="c-form__next" for="progress5" role="button">
                      <span class="c-form__nextIcon"
                        ><img src="../assets/img/signin-arrow-img.svg" alt=""
                      /></span>
                    </label>

                    <span class="c-form__groupLabel">{{
                      $t("CONFIRM PASSWORD")
                    }}</span>
                    <b class="c-form__border"></b>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./6 -->

                <!-- 7 -->
                <div class="c-form__group pdf-area">
                  <label class="c-form__label" for="fpass2">
                    <div class="pdf">
                      <img src="../assets/pdf/terms-pdf-1.jpg" alt="" />
                      <img src="../assets/pdf/terms-pdf-2.jpg" alt="" />
                      <img src="../assets/pdf/terms-pdf-3.jpg" alt="" />
                      <img src="../assets/pdf/terms-pdf-4.jpg" alt="" />
                      <img src="../assets/pdf/terms-pdf-5.jpg" alt="" />
                      <img src="../assets/pdf/terms-pdf-6.jpg" alt="" />
                      <img src="../assets/pdf/terms-pdf-7.jpg" alt="" />
                      <img src="../assets/pdf/terms-pdf-8.jpg" alt="" />
                    </div>
                    <!-- 利用規約に同意する -->
                    <div class="input-area">
                      <label class="cover-label" for="check">
                        <input
                          type="checkbox"
                          name=""
                          id="check"
                          placeholder=" "
                          v-model="userCheck"
                        />
                        {{ $t("I agree with the Terms") }}
                      </label>
                      <span
                        class="circle"
                        v-bind:class="{
                          done: hasChecked,
                        }"
                      >
                        <span class="bar"></span>
                      </span>
                    </div>
                    <label
                      class="done-btn c-form__nextIcon"
                      for="finish"
                      role="button"
                      v-bind:class="{
                        done: hasChecked,
                      }"
                    >
                      {{ $t("Completed") }}
                    </label>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./7 -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <Footer title="Sign up" />
  </div>
</template>

<style lang="less" scoped>
.header {
  /deep/ .grade {
    display: none !important;
  }
  /deep/ .detail {
    display: none !important;
  }
}
.signup-page {
  /deep/ .fix-bar {
    padding: 60px 0 80px;
  }
  /deep/ .footer {
    padding-bottom: 0;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 9;
    .footer-fixed-menu {
      display: none;
    }
    .page-nav {
      display: none;
    }
    .language {
      .logo {
        img {
          display: none;
        }
      }
      .select-box {
        @media screen and (min-width: 767px) {
          margin-top: 0;
        }
      }
    }
  }
}
</style>

<script>
import $ from "jquery";
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Signup",
  components: {
    Header,
    HeaderMenu,
    Footer,
  },
  data: () => {
    return {
      userCheck: "",
      userCheck2: "",
    };
  },
  methods: {
    toReturnBtn() {
      this.$router.push("/top");
    },
  },
  computed: {
    hasChecked() {
      return this.userCheck;
    },
    hasChecked2() {
      return this.userCheck2;
    },
  },
  mounted: function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");

    var ua = navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        var viewportContent = viewport.getAttribute("content");
        viewport.setAttribute(
          "content",
          viewportContent + ", user-scalable=no"
        );
      }
    }

    $(".signup-page .c-form__toggle").on("click", function () {
      $(".fix-bar").fadeOut("slow");
    });
    $(".c-welcome .link-btn").on("click", function () {
      $(".shutter")
        .css("display", "block")
        .delay(2090)
        .queue(function () {
          location.href = "./";
          $(this).dequeue();
        });
    });

    $(".c-form__toggle").on("click", function () {
      $(".c-form__toggle").addClass("remove");
      $(".c-form__group:nth-child(1)").addClass("active");
    });
    $(".c-form__group:nth-child(1) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(1)").removeClass("active");
      $(".c-form__group:nth-child(2)").addClass("active");
      $(".c-form__progress").addClass("progress1");
    });
    $(".c-form__group:nth-child(1) .return-txt").on("click", function () {
      $(".c-form__toggle").removeClass("remove");
      $(".c-form__group:nth-child(1)").removeClass("active");
    });

    $(".c-form__group:nth-child(2) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(2)").removeClass("active");
      $(".c-form__group:nth-child(3)").addClass("active");
      $(".c-form__progress").addClass("progress2");
    });
    $(".c-form__group:nth-child(2) .return-txt").on("click", function () {
      $(".c-form__group:nth-child(2)").removeClass("active");
      $(".c-form__group:nth-child(1)").addClass("active");
      $(".c-form__progress").removeClass("progress1");
    });

    $(".c-form__group:nth-child(3) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(3)").removeClass("active");
      $(".c-form__group:nth-child(4)").addClass("active");
      $(".c-form__progress").addClass("progress3");
    });
    $(".c-form__group:nth-child(3) .return-txt").on("click", function () {
      $(".c-form__group:nth-child(3)").removeClass("active");
      $(".c-form__group:nth-child(2)").addClass("active");
      $(".c-form__progress").removeClass("progress2");
    });

    $(".c-form__group:nth-child(4) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(4)").removeClass("active");
      $(".c-form__group:nth-child(5)").addClass("active");
      $(".c-form__progress").addClass("progress4");
    });
    $(".c-form__group:nth-child(4) .return-txt").on("click", function () {
      $(".c-form__group:nth-child(4)").removeClass("active");
      $(".c-form__group:nth-child(3)").addClass("active");
      $(".c-form__progress").removeClass("progress3");
    });

    $(".c-form__group:nth-child(5) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(5)").removeClass("active");
      $(".c-form__group:nth-child(6)").addClass("active");
      $(".c-form__progress").addClass("progress5");
    });
    $(".c-form__group:nth-child(5) .return-txt").on("click", function () {
      $(".c-form__group:nth-child(5)").removeClass("active");
      $(".c-form__group:nth-child(4)").addClass("active");
      $(".c-form__progress").removeClass("progress4");
    });

    $(".c-form__group:nth-child(6) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(6)").removeClass("active");
      $(".c-form__group:nth-child(7)").addClass("active");
      $(".c-form__progress").addClass("progress6");
    });
    $(".c-form__group:nth-child(6) .return-txt").on("click", function () {
      $(".c-form__group:nth-child(6)").removeClass("active");
      $(".c-form__group:nth-child(5)").addClass("active");
      $(".c-form__progress").removeClass("progress5");
    });

    // $(".c-form__group:nth-child(7) .c-form__nextIcon").on("click", function () {
    //   $(".c-form__group:nth-child(7)").removeClass("active");
    //   $(".c-form__group:nth-child(8)").addClass("active");
    //   $(".c-form__progress").addClass("progress7");
    // });
    // $(".c-form__group:nth-child(7) .return-txt").on("click", function () {
    //   $(".c-form__group:nth-child(7)").removeClass("active");
    //   $(".c-form__group:nth-child(6)").addClass("active");
    //   $(".c-form__progress").removeClass("progress6");
    // });

    $(".c-form__group:nth-child(7) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(7)").removeClass("active");
      $(".c-formContainer .c-form").addClass("active");
      $(".c-formContainer .c-welcome").addClass("active");
      $(".c-form__progress").addClass("progress7");
    });
    $(".c-form__group:nth-child(7) .return-txt").on("click", function () {
      $(".c-form__group:nth-child(7)").removeClass("active");
      $(".c-form__group:nth-child(6)").addClass("active");
      $(".c-form__progress").removeClass("progress6");
    });
  },
};
</script>
